import { Box, Checkbox, Flex, Text } from '@chakra-ui/react';
import type { Country } from '@/models/country';
import { CountryTag } from '@/components/CountryTag';

export function SwapTeamRow(props: {
  rank: number;
  country: Country;
  index: number;
  compact?: boolean;
  rankFontSize?: number;
  spacing?: number | string;
  minH?: number | string | object;
  checkboxDisabled?: boolean;
  /** When true, checkbox is decorative (checked state fixed, not in CheckboxGroup). */
  illustrative?: boolean;
  illustrativeChecked?: boolean;
}) {
  const {
    rank,
    country,
    index,
    compact = false,
    rankFontSize = 16,
    spacing = 2,
    minH = { base: '3rem', md: 'auto' },
    checkboxDisabled = false,
    illustrative = false,
    illustrativeChecked = false,
  } = props;

  return (
    <Flex
      align='center'
      gap={3}
      py={spacing}
      px={2}
      borderRadius='md'
      minH={minH}
      bg={illustrative ? { base: 'blackAlpha.50', _dark: 'whiteAlpha.50' } : undefined}
    >
      <Text
        fontWeight='semibold'
        fontSize={rankFontSize}
        w='2rem'
        textAlign='center'
        flexShrink={0}
        color='chakra-body-text'
      >
        {rank}
      </Text>
      <Box flex={1} minW={0} display='flex' justifyContent='center'>
        <CountryTag country={country} compact={compact} />
      </Box>
      {illustrative ? (
        <Checkbox
          isChecked={illustrativeChecked}
          isDisabled
          size='lg'
          colorScheme='green'
          opacity={1}
          sx={{
            '&[data-disabled]': { opacity: 1 },
            '& .chakra-checkbox__control[data-disabled][data-checked]': {
              bg: 'green.500',
              borderColor: 'green.500',
              color: 'white',
              opacity: 1,
            },
            '& .chakra-checkbox__control[data-disabled][data-checked] svg': {
              stroke: 'white',
            },
          }}
        />
      ) : (
        <Checkbox
          value={index.toString()}
          isDisabled={checkboxDisabled}
          size='lg'
          colorScheme='green'
        />
      )}
    </Flex>
  );
}
